module.exports = __webpack_public_path__ + "img/log.0f6f4884.png";